import comp from '../components/barrel';
import {mountLeadForm, applyLeadTypeVisibility, collectLeadForm, validateLeadForm, markLeadFormClean, appendLeadSourceFields, SOURCE_OF_LEAD_OTHER} from '../js/leadForm';

const USER_EP = 'users/get-user-details';
const MARKETERS_EP = 'communal/marketers';
const CREATE_EP = 'advisors/create-lead';

function cellText(val) {
  return val != null && String(val).trim() !== '' ? String(val) : '';
}

export default {
  formReady: false,

  async prepare() {
    const {value: loggedInUuid} = await O.getCookie('ewttgpvwwkf');
    this.loggedInUuid = loggedInUuid || null;
    this.recipe.methods.push(await O.mPOST(MARKETERS_EP, {}));
    if (loggedInUuid) {
      this.recipe.methods.push(await O.mPOST(USER_EP, {target_user_uuid: loggedInUuid}));
    }
  },

  async render() {
    const rec = this.recipe.methods;
    let data = {};
    if (rec.length) data = await O.PREP(rec);
    const userDetails = data[USER_EP]?.data;
    this.loggedInRoleText = userDetails?.role_text || null;
    this.isMarketer = (this.loggedInRoleText || '').trim().toLowerCase() === 'marketer';
    const marketersRes = data[MARKETERS_EP] || {};
    this.marketersData = Array.isArray(marketersRes.data)
      ? marketersRes.data.map((row) => ({
          ...row,
          fullName: `${cellText(row.f_name)} ${cellText(row.s_name)}`.trim() || cellText(row.user_uuid),
        }))
      : [];
    await this.loadPage();
  },

  async loadPage() {
    const gate = U.id('leadMarketerGate');
    const form = U.id('leadForm');
    if (this.isMarketer) {
      if (gate) gate.innerHTML = '';
      this.formReady = true;
      await mountLeadForm(form, {isMarketer: true, marketers: [], lead: null, showMarketer: false, showSource: true});
      this.setFormEnabled(true);
      return;
    }
    if (gate) {
      gate.innerHTML = '';
      gate.appendChild(
        await comp.select_v2({
          elID: 'addLeadMarketerDD',
          ddData: this.marketersData,
          valueDataName: 'user_uuid',
          textDataName: 'fullName',
          labelName: 'Allocate to marketer',
          requiredYN: 1,
          onchange: 'thsPage.onMarketerChosen()',
        })
      );
      await appendLeadSourceFields(gate);
      gate.appendChild(
        await comp.select_v2({
          elID: 'leadSourceOfLeadDD',
          ddData: [{user_uuid: SOURCE_OF_LEAD_OTHER, fullName: 'Other/not marketer'}, ...this.marketersData],
          valueDataName: 'user_uuid',
          textDataName: 'fullName',
          labelName: 'Source of lead',
          requiredYN: 1,
        })
      );
    }
    this.formReady = false;
    if (form) form.innerHTML = '';
    this.setFormEnabled(false);
  },

  async onMarketerChosen() {
    const chosen = U.id('addLeadMarketerDD');
    const marketer_uuid = chosen ? String(chosen.value || '').trim() : '';
    const form = U.id('leadForm');
    if (!marketer_uuid) {
      this.formReady = false;
      if (form) form.innerHTML = '';
      this.setFormEnabled(false);
      return;
    }
    if (!this.formReady) {
      await mountLeadForm(form, {
        isMarketer: false,
        marketers: this.marketersData,
        lead: {marketer_uuid},
        showMarketer: false,
      });
      this.formReady = true;
    }
    this.setFormEnabled(true);
  },

  onLeadTypeChange() {
    applyLeadTypeVisibility();
  },

  setFormEnabled(enabled) {
    const btn = U.id('saveLeadBtn');
    if (btn) btn.disabled = !enabled;
    const form = U.id('leadForm');
    if (form) form.style.display = enabled ? '' : 'none';
  },

  async saveLead() {
    if (!this.formReady && !this.isMarketer) {
      comp.toast('Choose a marketer before capturing the lead');
      return;
    }
    const payload = collectLeadForm();
    if (!this.isMarketer) {
      const gate = U.id('addLeadMarketerDD');
      payload.marketer_uuid = gate ? String(gate.value || '').trim() : payload.marketer_uuid;
      if (!payload.marketer_uuid) {
        comp.toast('Choose a marketer before capturing the lead');
        return;
      }
    }
    const error = validateLeadForm(payload);
    if (error) {
      comp.toast(error);
      return;
    }
    if (this.isMarketer) {
      payload.marketersource = this.loggedInUuid || null;
    } else {
      const chosen = payload.source_of_lead;
      payload.marketersource = !chosen || chosen === SOURCE_OF_LEAD_OTHER ? null : chosen;
    }
    delete payload.source_of_lead;
    try {
      const res = await O.PREP([await O.mPOST(CREATE_EP, payload)]);
      const result = res[CREATE_EP] || {};
      if (result.status === 'OK' && result.data && result.data.lead_uuid) {
        comp.toast('Lead added');
        markLeadFormClean();
        O.PREP('ViewLead', `lead_uuid=${result.data.lead_uuid}`);
        return;
      }
      comp.toast((result.data && result.data.error) || 'Unable to add lead');
    } catch (e) {
      comp.toast('Unable to add lead');
    }
  },
};
